import React ,{useEffect, useeffect,useState} from "react"
import * as Yup from "yup"
import axiosInstance from "../../../utils/axiosInstance";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import Swal from "sweetalert2";

const baseUrl = process.env.REACT_APP_BASE_URL;

const validationSchema = Yup.object({
  code: Yup.string()
    .required("Code is required")
    .max(10, "Le code ne peut pas dépasser 10 caractères"),
    
  name: Yup.string()
    .required("Name is required"),
    
  email: Yup.string()
    .transform(value => value === "" ? null : value)
    .nullable()
    .email("Email invalide"),
    
  adresse: Yup.string()  // Attention : nom des propriétés sensible à la casse
});
const initialValues={
    code:"",
    name:"",
    email:"",
    adresse:"",
    parDefaut:false
}
const Depot=()=>{
const [depots,setDepots]=useState([])  //initier les valeures si on veut mettre des valeures [{ id: 1, title: "React" }, { id: 2, title: "Node.js" }]
const [loading,setLoading]=useState(null)
const [selectedDepot, setSelectedDepot] = useState(null);
// const token=localStorage.getItem("token")

const fetchDepots=()=>{
 axiosInstance.get(`${baseUrl}/api/Depots/warehouses`)
            .then(res => setDepots(res.data.value))
            .catch(() => console.log("Impossible de charger les depôts"))
            .finally(() => setLoading(false));
}

useEffect(()=>{
    fetchDepots()
},([]))
const handleEdit =(depot)=>{
    console.log(depot)
    setSelectedDepot(depot)
      formik.setValues({
            ...depot,
            // parDefaut: depot.parDefaut ?? "",
        });
   setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);     
}
const resetForm=()=>{
        formik.resetForm();
        setSelectedDepot(null);
}
 const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.delete(`${baseUrl}/api/Depots`, { 'id': id, 'idString': '' })
                    .then(() => fetchDepots());
            }
        });
    };
  const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {

            const url = values.id
                ? `${baseUrl}/api/Depots/UpdateDepot`
                : `${baseUrl}/api/Depots/Create`;

            const payload = {
                ...values,
                //  parDefaut : values.parDefaut===""?false:true,
            };
            try {
                 values.id
                ? await axiosInstance.put(url, payload):await axiosInstance.post(url, payload)

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchDepots();
                resetForm();
                setSelectedDepot(null);

            } catch (error) {

                // 🔴 erreurs ServiceResponse
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                    console.log(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });

// console.log(depots)
return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Dépôts</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" >
                <i className="fas fa-plus"></i> Ajouter
            </button>
             {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title="Liste des dépôts"
                    columns={["code", "name", "adresse","email","parDefaut"]}
                    columnsMapping={{
                        name: "Nom",
                        code: "Code",
                        adresse: "Adresse",
                        email: "Email",
                        parDefaut:"Defaut"
                    }}
                    keyField="id"
                    data={depots}
                    handleEdit={handleEdit}
                     handleDelete={(id) => handleDelete(id)}
                />
            )}
             <div className="modal fade" id="modalForm">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedDepot ? "Modifier" : "Ajouter"} un dépôt</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Code</label>
                                <input
                                    type="text"
                                    name="code"
                                    className={`form-control ${formik.touched.code && formik.errors.code ? "is-invalid" : ""}`}
                                    value={formik.values.code}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.code}
                                </div>
                            </div>
                            <div className="form-group">
                                    <label>Nom</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""}`}
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <div className="invalid-feedback">
                                        {formik.errors.name}
                                    </div>
                            </div>
                            <div className="form-group">
                                            <label>Adresse</label>
                                            <input
                                                type="text"
                                                name="adresse"
                                                className={`form-control ${formik.touched.adresse && formik.errors.adresse ? "is-invalid" : ""}`}
                                                value={formik.values.adresse}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <div className="invalid-feedback">
                                                {formik.errors.adresse}
                                            </div>
                            </div>
                            <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                type="text"
                                                name="email"
                                                className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                           />
                                           <div className="invalid-feedback">
                                             {formik.errors.email}
                                           </div>
                            </div>
                            <div className="form-group col-md-6">
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="checkbox"
                                            name="parDefaut"
                                            className={`form-control ${formik.touched.parDefaut && formik.errors.parDefaut ? "is-invalid" : ""}`}
                                            value={formik.values.parDefaut}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                        <label > Defaut</label>
                                    </div>
                            </div>
                        </div> 
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={resetForm} data-dismiss="modal">Annuler</button>
                            <button className="btn btn-enregistrer" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div> 
         </div> 
        )
}
export default Depot